export function module_common() {
  $(function() {
    //--------------------------------------------------------
    // Resize Event
    //--------------------------------------------------------
    // 共通リサイズイベント関数の定義
    function commonResize() {
      if (window.innerWidth >= 1000) {
        // SPメニュー表示時の背景固定用クラスを削除
        $('body').removeClass('fixed').css('top', '');
        $('header, .gNav, .gNav__inner, .menuBtn').removeClass('active');
        $('.gNav, .gNav__inner, main').removeAttr('style');
        
        // クリックイベント削除
        $(".gNav, .menuBtn").off("click");
        
        // スクロールイベントをいったん解除
        $(window).off('scroll.headerFixed');
        
        // スクロール時のヘッダー固定 (PC用)
        $(window).on('scroll.headerFixed', function() {
          var headerHeight = $(".content__title").height();
          
          if ($(this).scrollTop() > headerHeight) {
            $(".header").addClass("fixed");
          } else {
            $(".header").removeClass("fixed");
          }
        });
      } else {
        // スマホ・タブレット用設定
        $('.gNav').removeClass('fixed');
        
        // ヘッダー高さを取得して設定
        var headerHeight = $('header').outerHeight();
        $('.gNav__inner').css('top', headerHeight);
        
        // スクロールイベントをいったん解除
        $(window).off('scroll.headerFixed');
        
        // スクロール時のヘッダー固定 (SP用)
        $(window).on('scroll.headerFixed', function() {
          var headerHeight = $(".content__title").height();
          
          if ($(this).scrollTop() > headerHeight) {
            $(".header").addClass("fixed");
          } else {
            $(".header").removeClass("fixed");
          }
        });
        
        // クリックイベントをいったん解除
        $(".gNav, .menuBtn").off("click");
        
        //--------------------------------------------------------
        // スマホ・タブレット時メニュー
        //--------------------------------------------------------
        var state = false;
        var scrollpos;
        
        $('.menuBtn, .gNav').on('click', function(event) {
          if (state === false) {
            // 背景コンテンツ固定
            scrollpos = $(window).scrollTop();
            $('body').addClass('fixed').css({
              'top': -scrollpos
            });
            
            // グローバルメニュー表示
            $('header, .gNav, .gNav__inner, .menuBtn').addClass('active');
            state = true;
          } else {
            // 背景コンテンツ固定 解除
            $('body').removeClass('fixed').css({
              'top': 0
            });
            window.scrollTo(0, scrollpos);
            
            // グローバルメニュー非表示
            $('header, .gNav, .gNav__inner, .menuBtn').removeClass('active');
            state = false;
          }
        });
      }
    }
    
    // 初期実行
    commonResize();
    
    // リサイズ処理
    var timer = false;
    var winWidth = $(window).width();
    var winHeight = $(window).height();
    
    $(window).on("resize", function() {
      // リサイズ中の連続実行を防止
      if (timer !== false) {
        clearTimeout(timer);
      }
      
      // 指定時間後に処理を実行
      timer = setTimeout(function() {
        // リサイズ後のウインドウのサイズを取得
        const winWidth_resized = $(window).width();
        const winHeight_resized = $(window).height();
        
        // サイズが変わった場合のみ処理を実行
        if (winWidth !== winWidth_resized || winHeight !== winHeight_resized) {
          commonResize();
          
          // 次回比較用にサイズを更新
          winWidth = winWidth_resized;
          winHeight = winHeight_resized;
        }
      }, 200);
    });
    
    //--------------------------------------------------------
    // PAGETOP
    //--------------------------------------------------------
    var topBtn = $('.pagetop');
    topBtn.hide();
    
    // スクロールイベントは名前空間を使用
    $(window).on('scroll.pageTop', function() {
      if ($(this).scrollTop() > 160) {
        topBtn.fadeIn();
      } else {
        topBtn.fadeOut();
      }
    });
    
    // スクロールしてトップ
    topBtn.on('click', function() {
      $('body,html').animate({
        scrollTop: 0
      }, 1500, 'easeInOutQuart');
      return false;
    });
  });
}